import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "promo-wrap pt-100 pb-75" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = ["data-aos-delay"]
const _hoisted_5 = { class: "promo-card style2" }
const _hoisted_6 = { class: "promo-title" }
const _hoisted_7 = { class: "promo-icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.features, (feature) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-xl-4 col-lg-6 col-md-6",
            key: feature.id,
            "data-aos": "fade-left",
            "data-aos-duration": "1200",
            "data-aos-delay": feature.datadelay
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("i", {
                    class: _normalizeClass(feature.icon)
                  }, null, 2)
                ]),
                _createElementVNode("h3", null, _toDisplayString(feature.title), 1)
              ]),
              _createElementVNode("p", null, _toDisplayString(feature.shortDesc), 1)
            ])
          ], 8, _hoisted_4))
        }), 128))
      ])
    ])
  ]))
}